import { api } from "@/lib/axios";
import type {
  ApiResponse,
  UpsertDispatchSettingsRequest,
  CompanySystemTemplate,
  UpsertCompanySystemTemplateRequest,
} from "../types/company.types";

/** 게스트 주문 등록 SMS 시스템 템플릿 타입 키 (백엔드 SmsSystemTemplateTypes와 일치) */
export const GUEST_ORDER_TEMPLATE_TYPE = "GUEST_ORDER_REGISTRATION";

// --- 배차 업체 부가정보(ul_company_dispatch) ---

export const upsertDispatchSettings = async (
  req: UpsertDispatchSettingsRequest,
): Promise<void> => {
  const { data } = await api.post<ApiResponse<null>>(
    "/api/Company/Admin/Upsert-Dispatch-Settings",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
};

/**
 * 결제타입 목록 조회 (ul_sys_item PAYMENT_METHOD).
 * ULA 화물 등록 화면의 결제방식 드롭다운과 같은 소스 — Admin에서 목록을 따로 하드코딩하면 값이 갈린다.
 */
export const getPaymentMethods = async (): Promise<string[]> => {
  const { data } = await api.get<ApiResponse<string[]>>(
    "/api/etc/PaymentMethods",
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result.filter((m) => m);
};

// --- 업체별 시스템 SMS 템플릿 (게스트 등록) ---

export const getCompanySystemTemplate = async (
  companyGuid: string,
  templateType: string,
): Promise<CompanySystemTemplate> => {
  const { data } = await api.get<ApiResponse<CompanySystemTemplate>>(
    "/api/SmsTemplate/Admin/Get-Company-System-Template",
    { params: { companyGuid, templateType } },
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const upsertCompanySystemTemplate = async (
  req: UpsertCompanySystemTemplateRequest,
): Promise<void> => {
  const { data } = await api.post<ApiResponse<boolean>>(
    "/api/SmsTemplate/Admin/Upsert-Company-System-Template",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
};

export const deleteCompanySystemTemplate = async (
  companyGuid: string,
  templateType: string,
): Promise<void> => {
  const { data } = await api.post<ApiResponse<boolean>>(
    "/api/SmsTemplate/Admin/Delete-Company-System-Template",
    { CompanyGuid: companyGuid, TemplateType: templateType },
  );
  if (data.code !== 200) throw new Error(data.message);
};
